import { ErrorLogComponent } from '@cian/error-log-component';
import { ILogger } from '@cian/logger';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { Gallery } from 'shared/components/NewbuildingGallery';
import { useNewbuildingMedia } from 'shared/containers/NewbuildingGalleryContainer/utils/useNewbuildingMedia';
import { GallerySidebarContainer } from 'shared/containers/NewbuildingGallerySidebar';
import { hideFullScreen, showFullScreen } from 'shared/store/gallery';

import { trackFullscreenOpen } from './tracking';

interface IGalleryContainerProps {
  reactErrorLogger: ILogger;
  phoneButton?: boolean;
  favoritesButton?: boolean;
}

export const GalleryContainer: React.FC<React.PropsWithChildren<IGalleryContainerProps>> = ({ reactErrorLogger }) => {
  const dispatch = useDispatch();
  const media = useNewbuildingMedia();

  const onFullscreenOpen = React.useCallback(() => {
    trackFullscreenOpen();
    dispatch(showFullScreen(0));
  }, [dispatch]);

  const onFullscreenClose = React.useCallback(() => {
    dispatch(hideFullScreen());
  }, [dispatch]);

  return (
    <div data-testid="OfferGallery" data-name="OfferGallery" id="photos">
      <ErrorLogComponent logger={reactErrorLogger}>
        <Gallery
          slotFullscreenSidebar={<GallerySidebarContainer />}
          media={media}
          onFullscreenOpen={onFullscreenOpen}
          onFullscreenClose={onFullscreenClose}
        />
      </ErrorLogComponent>
    </div>
  );
};
